import axios from "axios"

import { aplicarInterceptorToken } from "./interceptor-token.js"

const autenticacao = axios.create({
  baseURL: process.env.NODE_ENV !== "production" ? "https://localhost:7139/" : "https://backendvm01.ufn.edu.br/autenticacao/",
  headers: {
    Accept: "application/json",
    Content: "application/json",
  },
})

aplicarInterceptorToken(autenticacao)

export default autenticacao
